module.exports = __webpack_public_path__ + "img/orbit-card-total-usd-rewards.b9865332.png";